export default __webpack_public_path__ + "static/media/languageicon_new.8e021ef6.png";